import Vue from 'vue'
import OAuth2 from '@gravela/vue-oauth2-plugin'

Vue.use(OAuth2)
